var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeverity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.50002 2.61547V7.69146C1.50004 9.29592 1.98624 10.8627 2.89453 12.1853C3.80282 13.5078 5.09057 14.5241 6.58802 15.1001L7.28204 15.3668C7.74418 15.5446 8.25584 15.5446 8.71804 15.3668L9.41204 15.1001C10.9095 14.5241 12.1972 13.5078 13.1055 12.1853C14.0138 10.8627 14.5 9.29592 14.5 7.69146V2.61547C14.5013 2.42446 14.4474 2.23714 14.3447 2.07606C14.242 1.91498 14.095 1.78698 13.9214 1.70747C12.0546 0.892662 10.0368 0.481241 8.00004 0.500134C5.96326 0.481241 3.94546 0.892662 2.07869 1.70747C1.90501 1.78698 1.758 1.91498 1.65534 2.07606C1.55268 2.23714 1.49875 2.42446 1.50002 2.61547Z",
    stroke: "currentColor",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.5C7.86193 9.5 7.75 9.38807 7.75 9.25C7.75 9.11193 7.86193 9 8 9",
    stroke: "currentColor",
    strokeWidth: 0.666667
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.5C8.13807 9.5 8.25 9.38807 8.25 9.25C8.25 9.11193 8.13807 9 8 9",
    stroke: "currentColor",
    strokeWidth: 0.666667
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 7.5V4.5",
    stroke: "currentColor",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeverity);
export default __webpack_public_path__ + "static/media/severity.6af215b5.svg";
export { ForwardRef as ReactComponent };